<template>
  <v-container fluid>
    <h2 class="mb-3"> {{ b2b.customerDictionary[id].Name}} ({{ b2b.customerDictionary[id].Email}})</h2>
    <v-layout class=" " row wrap>
      <v-flex lg3 class="no-print">

        <v-toolbar color="secondary" dark class="mb-2">
          <h3> Τελευταίες Παραγγελίες</h3>
        </v-toolbar>

        <v-data-iterator
          class="sidebars-areas scroll-y"
          :items="orders"
          row
          wrap
          hide-actions
          :rows-per-page-items="[-1]"
          content-tag="v-layout"
        >
          <v-flex lg12
                  slot="item"
                  slot-scope="props"
          >
            <v-card class="mb-3" :color="active === props.item.ID?'blue lighten-5':''">
              <v-card-title>
                {{props.item.OfferName}}
              </v-card-title>
              <v-card-title>
                {{props.item.OrderDate | moment("DD/MM - HH:mm:ss")}}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text v-if="props.item.Notes"> {{props.item.Notes}}</v-card-text>
              <v-card-actions>
                <v-chip color="primary" text-color="white" m-r-1> {{props.item.Price | priceFormat }} </v-chip>
                <v-chip v-if="active === props.item.ID"  color="default"  m-r-1> {{orderDetails.length }} Προϊόντα </v-chip>
                <v-spacer></v-spacer>
                <v-btn v-if="active !== props.item.ID" @click="getOrders(props.item.ID,props.item)"> Λεπτομέρειες
                </v-btn>
                <v-btn v-if="active === props.item.ID" @click="print()"> Εκτύπωση</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-data-iterator>

        <v-toolbar color="secondary" dark class="mb-2">
          <h3> Tρέχουσες Προσφορες</h3>
        </v-toolbar>

        <v-data-iterator
          class="sidebars-areas scroll-y"
          :items="b2b.offerCustomers"
          row
          wrap
          hide-actions
          :rows-per-page-items="[-1]"
          content-tag="v-layout"
        >
          <v-flex lg12
                  slot="item"
                  slot-scope="props"
          >
            <v-card class="mb-3" :color="activeOffer === props.item.OfferID?'blue lighten-3':''">
              <v-card-title>
                <strong> {{b2b.offerDictionary[props.item.OfferID].Title}} </strong>
              </v-card-title>
              <v-card-actions>
                <v-btn v-if="activeOffer !== props.item.OfferID"
                       @click="getOfferDetails(props.item.OfferID)"> Λεπτομέρειες
                </v-btn>
                <v-btn v-if="activeOffer === props.item.OfferID" @click="print()"> Εκτύπωση</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-data-iterator>



      </v-flex>
      <v-flex lg9 class=" pl-3 table-areas scroll-y">
        <v-card v-if="activeOffer">
          <v-card-title>
            <v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-spacer>
          </v-card-title>
          <v-data-table
            :search="search"
            :headers="OfferDetailsHeaders"
            :items="offerDetails"
            class="elevation-1"
            hide-actions
            :rows-per-page-items="[-1]"
          >
            <template slot="items" slot-scope="props">
              <td class="">{{ props.item.ProductID }}</td>
              <td class="">{{ props.item.ProductName }}</td>
              <td class="">{{ props.item.BasePrice | priceFormat }}</td>
              <td>
                <discount :discount="Number(props.item.Discount)"></discount>
              </td>
              <td class="">
                <price :price="Number(props.item.BasePrice)"
                       :discount="Number(props.item.Discount)"></price>
              </td>
              <td>
                <discount :customerOffer="Number(props.item.SpecialDiscount)"></discount>
              </td>
              <td class="">
                <price :price="Number(props.item.BasePrice)"
                       :customerOffer="Number(props.item.SpecialDiscount)"></price>
              </td>
            </template>
          </v-data-table>
        </v-card>

        <v-card v-if="active">
          <v-card-title>
            <v-text-field
              class="no-print"
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text v-if="order.Notes">
            <h4> Σημειώσεις:</h4>
            {{order.Notes}}
          </v-card-text>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="orderDetails"
            class="elevation-1"
            hide-actions
            :rows-per-page-items="[-1]"
          >
            <template slot="items" slot-scope="props">
              <td class="">{{ props.item.ProductID }}</td>
              <td class="">{{ props.item.ProductName }}</td>
              <td class="">{{ props.item.BasePrice | priceFormat }}</td>
              <td>
                <discount :customerOffer="Number(props.item.FinalDiscount)"></discount>
              </td>
              <td class="">
                <price :price="Number(props.item.BasePrice)"
                       :customerOffer="Number(props.item.FinalDiscount)"></price>
              </td>
              <td class="">
                {{props.item.Quantity}}
              </td>
              <td>
                {{props.item.Price | priceFormat}}
              </td>
            </template>
          </v-data-table>
        </v-card>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import ApiData from "@/assets/ApiData";
  import StoreState from "@/assets/StoreState";
  import Price from "@/components/Price";
  import Discount from "@/components/Discount";

  export default {
    name: "CustomerPage",
    components: {Discount, Price},
    data: () => ({
      search: '',
      active: 0,
      activeOffer: 0,
      b2b: StoreState.b2b,
      messages: StoreState.messages,
      orders: [],
      offers: [],
      offerDetails: [],
      id: 0,
      orderDetails: [],
      order:{},
      OfferDetailsHeaders: [
        {
          text: "Kωδ.",
          value: "ProductID",
        },
        {
          text: "Περιγραφή",
          value: "ProductName",
        },
        {
          text: "Τιμή Μ.",
          value: "BasePrice",
        },
        {
          text: "Έκπτ.",
          value: "Discount"
        },
        {
          text: "Tiμή Εκπτ.",
          value: "Discount"
        }, {
          text: "Εκπτ. Προσφοράς.",
          value: "SpecialDiscount"
        },
        {
          text: "Τιμή. Προσφ.",
        },
      ],
      headers:
        [
          {
            text: "Kωδ.",
            value: "ProductID",
          },
          {
            text: "Περιγραφή",
            value: "ProductName",
          },
          {
            text: "Τιμή Μ.",
            value: "BasePrice",
          },
          {
            text: "Έκπτ.",
            value: "FinalDiscount"
          },
          {
            text: "Τιμή Προσφ.",
          },
          {
            text: "Ποσ.",
            value: "Quantity"
          },
          {
            text: "Συν. Τιμή",
            value: "Price"
          }
        ]
    }),
    beforeMount() {
      this.id = this.$route.params.id;
      StoreState.filterRelations({customerID: this.id});
      ApiData.getCustomerOrders(this.id).then(resp => this.orders = resp.data.data)
    },
    mounted() {

    },
    methods: {
      print() {
        window.print();
      },
      getOfferDetails(id) {
        this.search = '';
        this.messages.isLoading = true;
        this.active = null;
        this.activeOffer = id;
        ApiData.getOfferDetails(id).then(resp => {
          this.messages.isLoading = false;
          this.offerDetails = resp.data.data;
        })
      },
      getOrders(id,order) {
        this.search = '';
        this.messages.isLoading = true;
        this.active = id;
        this.activeOffer = null;
        this.order = order;
        ApiData.getOrderDetails(id).then(resp => {
          this.messages.isLoading = false;
          this.orderDetails = resp.data.data;
        })
      }
    }

  }
</script>

<style scoped>

  .scroll-y {
    overflow: auto;
  }

  .sidebars-areas {
    max-height: 40vh;
  }

  .table-areas {
    max-height: 85vh;
  }

  @media print {
    .sidebars-areas {
      max-height: initial;
    }

    .table-areas {
      max-height: initial;
    }

    .no-print {
      display: none;
    }

    .v-toolbar {
      display: none;
    }

    body {
      overflow: auto;
      height: auto;
    }

    table {
      width: 100%;
      overflow-x: visible;
      padding: 0;
    }

    th {
      display: none;
    }

    div {
      padding: 0;
      margin: 0;
    }


    .scroll-y {
      height: auto;
      overflow: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/CustomerPage.vue